import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { FaGavel, FaUserTie, FaExclamationTriangle, FaBook, FaBalanceScale, FaLock, FaEnvelope, FaMapMarkerAlt, FaInfoCircle } from 'react-icons/fa';
import { BsShieldCheck, BsClipboardCheck } from 'react-icons/bs';
import Layout from '../components/layout/Layout';
import './LegalPages.css';

const TermsOfService = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Layout>
      <Container className="legal-page">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="text-center mb-5">
            <FaGavel size={48} className="text-primary mb-3" />
            <h1 className="page-title">Terms of Service</h1>
            <p className="last-updated">
              <FaInfoCircle className="me-2" />
              Last Updated: July 20, 2025
            </p>
          </div>
          
          <section className="mb-5">
            <p>
              Welcome to UniTrade! These Terms of Service ("Terms") govern your access to and use of the UniTrade 
              platform, including any content, functionality, and services offered on or through unitrade.com 
              (the "Service").
            </p>
            <p>
              Please read the Terms carefully before using the Service. By accessing or using the Service, you agree to 
              be bound by these Terms. If you do not agree to these Terms, you may not access or use the Service.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaInfoCircle className="me-2" />
              1. Introduction
            </h2>
            <p>To use certain features of the Service, you must register for an account. When you register, you agree to:</p>
            <ul>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain the security of your password and accept all risks of unauthorized access</li>
              <li>Be responsible for all activities that occur under your account</li>
              <li>Be at least 18 years old or the age of majority in your jurisdiction</li>
              <li>Be enrolled in or affiliated with a recognized educational institution</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaUserTie className="me-2" />
              2. User Responsibilities
            </h2>
            <p>As a user of UniTrade, you agree to:</p>
            <ul>
              <li>Use the Service only for lawful purposes</li>
              <li>Not engage in any fraudulent, deceptive, or illegal activities</li>
              <li>Not list prohibited items (weapons, drugs, stolen goods, etc.)</li>
              <li>Not infringe on any intellectual property rights</li>
              <li>Not interfere with or disrupt the Service or servers</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaExclamationTriangle className="me-2 text-warning" />
              3. Prohibited Activities
            </h2>
            <p>When using our platform to buy or sell items, you agree to:</p>
            <ul>
              <li>Provide accurate item descriptions and images</li>
              <li>Complete transactions in a timely manner</li>
              <li>Not engage in price manipulation or fee avoidance</li>
              <li>Pay all applicable fees and taxes</li>
              <li>Resolve disputes directly with the other party when possible</li>
            </ul>
            <p>
              UniTrade is not a party to any transactions between users and is not responsible for the quality, 
              safety, or legality of items listed on the platform.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaBook className="me-2 text-info" />
              4. Intellectual Property
            </h2>
            <p>
              You retain ownership of any content you post on UniTrade. By posting content, you grant us a 
              non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display such content 
              in connection with the Service.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaBalanceScale className="me-2 text-secondary" />
              5. Limitation of Liability
            </h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR 
              IMPLIED. UNITRADE DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF 
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p>
              IN NO EVENT SHALL UNITRADE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE 
              DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaLock className="me-2" />
              6. Indemnification
            </h2>
            <p>
              You agree to defend, indemnify, and hold harmless UniTrade and its officers, directors, employees, and 
              agents from any claims, liabilities, damages, losses, and expenses arising from:
            </p>
            <ul>
              <li>Your use of the Service</li>
              <li>Your violation of these Terms</li>
              <li>Your violation of any rights of a third party</li>
              <li>Any content you submit, post, or transmit through the Service</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <BsClipboardCheck className="me-2 text-primary" />
              7. Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these Terms at any time. We will provide notice of material changes 
              through the Service or by other means. Your continued use of the Service after such changes 
              constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="section-title">8. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of Ghana, without regard 
              to its conflict of law provisions.
            </p>
          </section>

          <section className="mt-5">
            <h2 className="section-title">
              <FaEnvelope className="me-2" />
              9. Contact Us
            </h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <address>
              <div className="d-flex align-items-center mb-2">
                <FaEnvelope className="me-2" />
                <strong>Email:</strong> support@unitradegh.com
              </div>
              <div className="d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                <strong>Address:</strong> University of Energy and Natural Resources, Sunyani, Ghana
              </div>
            </address>
          </section>
        </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default TermsOfService;
